import { Box, Button, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { toast } from 'material-react-toastify';
import { Order } from '../../../interfaces/Order/Order';
import { sharedStyles } from '../../../utils/Style';
import { shippingProvidersAtom } from '../../../atoms/ShippingProvider';

interface CargoCellProps {
  order: Order;
}

export const CargoCell = (props: CargoCellProps) => {
  const shippingProviders = useRecoilValue(shippingProvidersAtom);

  const handleClickCargoNo = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    navigator.clipboard
      .writeText(props.order.cargoNo ?? '')
      .then(() => toast.success('Kargo numarası panoya kopyalandı'));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
      <Typography sx={{ ...sharedStyles.body2 }}>
        {shippingProviders.find(
          (s) => s.id.toString() === props.order.shippingMethod,
        )?.name ?? props.order.shippingMethod}
      </Typography>

      {!!props.order.cargoNo && (
        <Button
          onClick={handleClickCargoNo}
          sx={{
            ...sharedStyles.body2,
            textTransform: 'none',
            p: 0,
            minWidth: 0,
            width: 'fit-content',
          }}
        >
          {props.order.cargoNo}
        </Button>
      )}
    </Box>
  );
};
